export default __webpack_public_path__ + "static/media/water dispenser cap.3372e8b1.jpeg";